import { forceSimulation, forceCenter, forceX, forceY, forceCollide } from './d3-force'

export default function (nodes, x, y, scale, cb) {
  const fy = .006 * x / y
  const fx = .004 * y / x
  let f = forceSimulation(nodes)
    .force("center", forceCenter(x/scale, y/scale))
    .force("collide", forceCollide().radius((d) => d.sd * 12).iterations(2).strength(1)  )
    //.force("charge", forceManyBody((d) => .008 + 0.002 * d.sd ** 2).distanceMin(.0001).distanceMax(.01))
    .force("y", forceY(() => y).strength((d) => Math.sqrt(d.sd) * fy))
    .force("x", forceX(() => x).strength((d) => Math.sqrt(d.sd) * fx))
    .alpha(1).alphaTarget(.04).alphaMin(.05).velocityDecay(.04).alphaDecay(.02)
    .on('tick', () => cb(nodes))

  f.resize = function(x, y, scale) {
    const fy = .006 * x / y
    const fx = .004 * y / x
    this.force("center", forceCenter(x/scale, y/scale))
    this.force("y", forceY(() => y).strength((d) => Math.sqrt(d.sd) * fy))
    this.force("x", forceX(() => x).strength((d) => Math.sqrt(d.sd) * fx))
    this.alpha(.4).restart()
  }
  f.resume = function() {
    this.stop()
    this.alpha(.4).restart()
  }
  return f
}
